const Joi = require("joi");
const ValidationTranslateFile = require("../../src/config/ValidationTranslateFile.jsx");
const currentLang = ValidationTranslateFile()

const purchaseHistoryschema = (data) => {
  const schema = Joi.object({
    fromDate: Joi.date().required().messages({
      "date.base": currentLang?.ValidationSchema?.Please_enter_Fromdate,
      "any.required": currentLang?.ValidationSchema?.Please_enter_Fromdate,
    }),
    toDate: Joi.date().min(Joi.ref("fromDate")).required().messages({
      "date.base": currentLang?.ValidationSchema?.Please_enter_Todate,
      "any.required": currentLang?.ValidationSchema?.Please_enter_Todate,
      "date.min": currentLang?.ValidationSchema?.Todate_must_greaterthan_or_equal_to_Fromdate,
    }),
  }).unknown(true); // Allow unknown keys in the object (useful if you're validating only part of the data)

  return schema.validate(data, { abortEarly: false });
};

module.exports = purchaseHistoryschema;
